import React from 'react'
import { withRouter } from 'react-router-dom'
import { pure } from 'recompose'
import MediaQuery from 'react-responsive'
import breakpoints from '../../styles/breakpoints'
import MainToolbarDesktop from './MainToolbarDesktop'
import MainToolbarMobile from './MainToolbarMobile'

const MainToolbar = () => (
  <MediaQuery minWidth={breakpoints.xs}>
    {matches => (matches ? <MainToolbarDesktop /> : <MainToolbarMobile />)}
  </MediaQuery>
)

export default withRouter(pure(MainToolbar))



// WEBPACK FOOTER //
// ./src/common/TopBar/MainToolbar.js